module.exports = __webpack_public_path__ + "static/media/close.36fc8753.svg";